import { TreeStore } from 'ynf-core-engine/stores'
import { extendObservable } from 'mobx'
import { arraysContain, getNodeChildren } from '../../utils/tools';

export default class NewTreeStore extends TreeStore {
  // [x: string]: any
  constructor (...props: any) {
    super(...props)
    this.rootStore = props[1];
    // this.multiple = this.rootStore.referInputProps.multiple
    this.multiple = this.rootStore.referInputProps.dataMultiple

    extendObservable(this, {
      // multiple: false
      // selectedKeys // 单选框
      // isDbclick: 1, // 双击触发
      maxLevel: 0,
      expandedKeys: []
    })
  }

  onExCheck = (val: any) => {
    this.selectedKeys = val

    this.checkedKeys = val
  }

  onExSelect = (val: any, node: any) => { // 做不了点击内容选中值，第二个参数传不过来
    if (this.multiple) {
    // this.checkedKeys = val
    } else {
      this.selectedKeys = val
    }
  }

  onExDoubleClick = (val: any) => {
    if (!this.multiple) {
      this.selectedKeys = [val]
      // this.isDbclick++
    }
  }

  onExExpand = (val: any) => {
    this.expandedKeys = val
  }

  createKeyMap = (data: Array<object>, parent: any) => {
    let keyMap: any = {}
    let maxLevel = 0
    data?.forEach((item: any) => {
      keyMap[item.id] = { ...item };
      if (parent?.realPath) {
        keyMap[item.id].realPath = [...parent.realPath, item.id]
      } else {
        keyMap[item.id].realPath = [item.id]
      }
      keyMap[item.id].level = parent ? parent.level + 1 : 1

      maxLevel = keyMap[item.id].realPath.length > maxLevel ? keyMap[item.id].realPath.length : maxLevel
      if (item.children?.length) {
        const res = this.createKeyMap(item.children, keyMap[item.id])
        keyMap = { ...res.keyMap, ...keyMap }
        maxLevel = maxLevel > res.maxLevel ? maxLevel : res.maxLevel
      }
    })
    return { keyMap, maxLevel }
  }

  setValue = (data: Array<object>) => {
    this.treeData = data
    const { keyMap, maxLevel } = this.createKeyMap(this.treeData, undefined)
    this.currMap = keyMap
    this.maxLevel = maxLevel
    this.keyMap = { ...this.keyMap, ...this.currMap }
    this.dataSource = data
  }

  getKeys = () => {
    if (this.multiple) {
      return this.getCheckedKeys()
    } else {
      return this.getSelectedKeys()
    }
  }

  getKeyNodes = () => {
    if (this.multiple) {
      return this.getCheckedNodes()
    } else {
      return this.getSelectedNodes()
    }
  }

  exSameLevelClick = (val: any) => {
    // const broList = Object.values(this.keyMap).filter((e: any) => e.level === val.level).map((e: any) => e.id)
    const broList = Object.values(this.keyMap).filter((e: any) => e.level === this.keyMap[val.id].level).map((e: any) => e.id)
    if (arraysContain(this.checkedKeys, broList)) { // 包含
      this.checkedKeys = this.checkedKeys.filter((e: any) => !broList.includes(e))
    } else { // 不包含
      this.checkedKeys = [...new Set([...this.checkedKeys, ...broList])]
    }
  }

  exSnextLevelClick = (val: any) => {
    const children = [val.id, ...getNodeChildren(val)]
    if (arraysContain(this.checkedKeys, children)) { // 包含
      this.checkedKeys = this.checkedKeys.filter((e: any) => !children.includes(e))
    } else { // 不包含
      this.checkedKeys = [...new Set([...this.checkedKeys, ...children])]
    }
  }
}
